/* 🤖 this file was generated by svg-to-ts */
export const matIconPlayDisabled: {
  name: 'play-disabled';
  data: string;
} = {
  name: 'play-disabled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M16.45 13.62 19 12 8 5v.17zM2.81 2.81 1.39 4.22 8 10.83V19l4.99-3.18 6.78 6.78 1.41-1.41L2.81 2.81zM10 15.36v-2.53l1.55 1.55-1.55.98z"/></svg>`
};
